export enum TransUnionProductType {
  CREDIT = 'Credit',
  CRIMINAL = 'Criminal',
  EVICTION = 'Eviction',
}
